import { Copy, KeyRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AccountCodeBanner() {
  const { user } = useAuth();
  const code = user?.account_code;
  if (!code) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(code); toast.success("ID copiado"); } catch { toast.error("No se pudo copiar"); }
  };
  return (
    <div className="flex flex-wrap items-center gap-4 rounded-2xl border border-[#E3E6FB] bg-[#F5F6FE] px-5 py-4" data-testid="account-code-banner">
      <div className="h-10 w-10 shrink-0 rounded-xl bg-white flex items-center justify-center shadow-sm">
        <KeyRound className="h-5 w-5 text-[#4C5BD8]" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-xs uppercase tracking-widest text-slate-500">Tu ID de cuenta</div>
        <p className="text-sm text-slate-600 mt-0.5">Escríbelo en la app del Fire Stick para que el dispositivo aparezca solo en tu cuenta.</p>
      </div>
      <button
        type="button"
        onClick={copy}
        className="flex items-center gap-3 rounded-xl bg-white px-4 py-2.5 shadow-sm transition-transform duration-200 hover:-translate-y-0.5"
        data-testid="account-code-copy-btn"
      >
        <span className="font-mono text-2xl font-semibold tracking-[0.25em] text-[#4C5BD8]" data-testid="account-code-value">{code}</span>
        <Copy className="h-4 w-4 text-slate-400" />
      </button>
    </div>
  );
}
